import React from 'react';
import { Redirect } from "react-router-dom"
import './Authorised.css';
import {
    Route,
} from "react-router-dom";
import { getToken } from "../../api/token";
import { LoadInfo } from "../LoadInfo";
import {Grid} from "@material-ui/core";
import {Navigation} from "../../components/Navigation";


export const AuthorizeContainer = ({ component: Component, ...rest }) => {
  let token = getToken();

  return (
      <Grid container justifyContent={"center"}>
          <Grid item xs={12}>
              <Navigation />
          </Grid>
          <Grid item xs={12}>
              <Route {...rest} render={props => (
                  token
                      ? <LoadInfo><Component {...props} /></LoadInfo>
                      : <Redirect to='/singin' />
              )} />
          </Grid>
      </Grid>
  );
};
